import React from "react";

export default {
    backend: {
        host: "https://the-politics-of-covid-19.com/search/api",
        index: "covid"
    },
    header: {
        logo: {
            img: "img/covid_logo.png",
            alt: "The Syllabus' Covid-19 Special Selection",
            href: "https://the-politics-of-covid-19.com/"
        },
        title: "Coronavirus Readings",
        intro: <span>{"Browse and search a wide range of analysis and commentary relevant to COVID-19 - across text, video and audio in multiple languages. Updated daily and powered by the curation technology - part-algorithmic, part-human - developed by"}{" "}<a href="https://the-syllabus.com/">{"The Syllabus."}</a><br /><a href={"https://the-politics-of-covid-19.com/special-edition/"}>{"To learn more and subscribe"}</a></span>,
    }
};
